export const SEARCH_WORK_ORDER_ASYNC = "SEARCH_WORK_ORDER_ASYNC";
export const SEARCH_WORK_ORDER_SUCCESS = "SEARCH_WORK_ORDER_SUCCESS";

export const CREATE_WORK_ORDER_ASYNC = "CREATE_WORK_ORDER_ASYNC";
export const CREATE_WORK_ORDER_SUCCESS = "CREATE_WORK_ORDER_SUCCESS";

export const CREATE_AND_SEND_WORK_ORDER_ASYNC =
  "CREATE_AND_SEND_WORK_ORDER_ASYNC";
export const CREATE_AND_SEND_WORK_ORDER_SUCCESS =
  "CREATE_AND_SEND_WORK_ORDER_SUCCESS";

export const CREATE_SCHEDULE_WORK_ORDER_ASYNC =
  "CREATE_SCHEDULE_WORK_ORDER_ASYNC";
export const CREATE_SCHEDULE_WORK_ORDER_SUCCESS =
  "CREATE_SCHEDULE_WORK_ORDER_SUCCESS";

export const UPDATE_WORK_ORDER_ASYNC = "UPDATE_WORK_ORDER_ASYNC";
export const UPDATE_WORK_ORDER_SUCCESS = "UPDATE_WORK_ORDER_SUCCESS";

export const SET_IS_UPLOADED = "SET_IS_UPLOADED";
export const BULK_UPDATE_MULTIPLE_WO_ASYNC = "BULK_UPDATE_MULTIPLE_WO_ASYNC";
export const UPLOAD_WORK_ORDER_ASYNC = "UPLOAD_WORK_ORDER_ASYNC";

export const ADD_EDIT_WORK_ORDER_ERROR = "ADD_EDIT_WORK_ORDER_ERROR";

export const RESET_WORK_ORDER = "RESET_WORK_ORDER";

export const GET_WORK_ORDER_BY_RFSID = "GET_WORK_ORDER_BY_RFSID";
export const GET_WORK_ORDER_BY_RFSID_SUCCESS =
  "GET_WORK_ORDER_BY_RFSID_SUCCESS";

export const GET_ALL_USER_EMAILS = "GET_ALL_USER_EMAILS";
export const GET_ALL_USER_EMAILS_SUCCESS = "GET_ALL_USER_EMAILS_SUCCESS";

export const GET_WORK_ORDER_DETAIL_ASYNC = "GET_WORK_ORDER_DETAIL_ASYNC";
export const GET_WORK_ORDER_DETAIL_SUCCESS = "GET_WORK_ORDER_DETAIL_SUCCESS";

export const OPEN_AN_AWAITING_WORK_ORDER_ASYNC =
  "OPEN_AN_AWAITING_WORK_ORDER_ASYNC";
export const OPEN_AN_AWAITING_WORK_ORDER_SUCCESS =
  "OPEN_AN_AWAITING_WORK_ORDER_SUCCESS";

export const SET_IS_UPDATED_OPEN_WORK_ORDER_FALSE =
  "SET_IS_UPDATED_OPEN_WORK_ORDER_FALSE";

export const SET_IS_REDIRECT_WORK_ORDER_FALSE =
  "SET_IS_REDIRECT_WORK_ORDER_FALSE";

export const RESOLVE_WORK_ORDER_ASYNC = "RESOLVE_WORK_ORDER_ASYNC";

export const SIGN_OFF_WORK_ORDER_ASYNC = "SIGN_OFF_WORK_ORDER_ASYNC";

export const DECLINE_WORK_ORDER_ASYNC = "DECLINE_WORK_ORDER_ASYNC";

export const PEND_WORK_ORDER_ASYNC = "PEND_WORK_ORDER_ASYNC";

export const OPEN_PENDING_WORK_ORDER_ASYNC = "OPEN_PENDING_WORK_ORDER_ASYNC";

export const PENDING_OPEN_WORK_ORDER_ASYNC = "PENDING_OPEN_WORK_ORDER_ASYNC";

export const PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_ASYNC =
  "PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_ASYNC";
export const PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_SUCCESS =
  "PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_SUCCESS";

export const SUBMIT_DECLINED_WORK_ORDER_ASYNC =
  "SUBMIT_DECLINED_WORK_ORDER_ASYNC";

export const RE_OPEN_WORK_ORDER_ASYNC = "RE_OPEN_WORK_ORDER_ASYNC";
export const EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC =
  "EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC";

export const REVIEW_RE_OPEN_WORK_ORDER_ASYNC =
  "REVIEW_RE_OPEN_WORK_ORDER_ASYNC";

export const GET_WORK_ORDER_COMMENTS_ASYNC = "GET_WORK_ORDER_COMMENTS_ASYNC";
export const GET_WORK_ORDER_COMMENTS_SUCCESS =
  "GET_WORK_ORDER_COMMENTS_SUCCESS";

export const GET_WORK_ORDER_PRIVATE_NOTES_ASYNC =
  "GET_WORK_ORDER_PRIVATE_NOTES_ASYNC";
export const GET_WORK_ORDER_PRIVATE_NOTES_SUCCESS =
  "GET_WORK_ORDER_PRIVATE_NOTES_SUCCESS";

export const ADD_WORK_ORDER_COMMENTS_ASYNC = "ADD_WORK_ORDER_COMMENTS_ASYNC";
export const ADD_WORK_ORDER_COMMENTS_SUCCESS =
  "ADD_WORK_ORDER_COMMENTS_SUCCESS";

export const DELETE_WORK_ORDER_PRIVATE_NOTES_ASYNC =
  "DELETE_WORK_ORDER_PRIVATE_NOTES_ASYNC";
export const DELETE_WORK_ORDER_PRIVATE_NOTES_SUCCESS =
  "DELETE_WORK_ORDER_PRIVATE_NOTES_SUCCESS";

export const UPLOAD_FILE_WORK_ORDER_ASYNC = "UPLOAD_FILE_WORK_ORDER_ASYNC";
export const UPLOAD_FILE_WORK_ORDER_SUCCESS = "UPLOAD_FILE_WORK_ORDER_SUCCESS";

export const UPLOAD_SIGNATURE_WORK_ORDER_ASYNC =
  "UPLOAD_SIGNATURE_WORK_ORDER_ASYNC";
export const UPLOAD_SIGNATURE_WORK_ORDER_SUCCESS =
  "UPLOAD_SIGNATURE_WORK_ORDER_SUCCESS";

export const UPLOAD_SIGNATURE_CHECK_STATUS = "UPLOAD_SIGNATURE_CHECK_STATUS";
export const UPLOAD_SIGNATURE_RESET_STATUS = "UPLOAD_SIGNATURE_RESET_STATUS";

export const SETUP_AWS_S3_ASYNC = "SETUP_AWS_S3_ASYNC";
export const SETUP_AWS_S3_SUCCESS = "SETUP_AWS_S3_SUCCESS";

export const UPLOAD_TO_SERVER_ASYNC = "UPLOAD_TO_SERVER_ASYNC";
export const UPLOAD_TO_SERVER_SUCCESS = "UPLOAD_TO_SERVER_SUCCESS";

export const UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_ASYNC =
  "UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_ASYNC";
export const UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_SUCCESS =
  "UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_SUCCESS";

export const DOWNLOAD_FILE_FROM_S3 = "DOWNLOAD_FILE_FROM_S3";

export const RESET_ATTACHMENTS = "RESET_ATTACHMENTS";

export const PRINT_PREVIEW_WORK_ORDER_ASYNC = "PRINT_PREVIEW_WORK_ORDER_ASYNC";
export const RESEND_NOTICE_ASYNC = "RESEND_NOTICE_ASYNC";

export const SIGN_OFF_UPLOAD_ATTACHMENT_TO_S3_ASYNC =
  "SIGN_OFF_UPLOAD_ATTACHMENT_TO_S3_ASYNC";
export const SIGN_OFF_UPLOAD_ATTACHMENT_TO_SERVER_ASYNC =
  "SIGN_OFF_UPLOAD_ATTACHMENT_TO_SERVER_ASYNC";

export const RESEND_PO_ASYNC = "RESEND_PO_ASYNC";

export const PRINT_PREVIEW_PURCHASE_ORDER_ASYNC =
  "PRINT_PREVIEW_PURCHASE_ORDER_ASYNC";

export const RESET_WORK_ORDER_PROFILE = "RESET_WORK_ORDER_PROFILE";
export const RESET_FILTER_NAME_PROFILE = "RESET_FILTER_NAME_PROFILE";

export const SEARCH_WORK_ORDER_LIST_ASYNC = "SEARCH_WORK_ORDER_LIST_ASYNC";
export const SEARCH_WORK_ORDER_LIST_SUCCESS = "SEARCH_WORK_ORDER_LIST_SUCCESS";
export const SEARCH_WORK_ORDER_LIST_FAIL = "SEARCH_WORK_ORDER_LIST_FAIL";

export const GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_ASYNC =
  "GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_ASYNC";
export const GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_SUCCESS =
  "GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_SUCCESS";
export const GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_FAIL =
  "GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_FAIL";

export const GET_BACK_CHARGE_DETAIL_ASYNC = "GET_BACK_CHARGE_DETAIL_ASYNC";
export const GET_BACK_CHARGE_DETAIL_SUCCESS = "GET_BACK_CHARGE_DETAIL_SUCCESS";
export const GET_BACK_CHARGE_DETAIL_FAIL = "GET_BACK_CHARGE_DETAIL_FAIL";

export const CREATE_BACK_CHARGE_ASYNC = "CREATE_BACK_CHARGE_ASYNC";
export const CREATE_BACK_CHARGE_SUCCESS = "CREATE_BACK_CHARGE_SUCCESS";
export const CREATE_BACK_CHARGE_FAIL = "CREATE_BACK_CHARGE_FAIL";

export const EDIT_BACK_CHARGE_ASYNC = "EDIT_BACK_CHARGE_ASYNC";
export const EDIT_BACK_CHARGE_SUCCESS = "EDIT_BACK_CHARGE_SUCCESS";
export const EDIT_BACK_CHARGE_FAIL = "EDIT_BACK_CHARGE_FAIL";

export const GET_WORK_ORDER_HISTORY_ASYNC = "GET_WORK_ORDER_HISTORY_ASYNC";
export const GET_WORK_ORDER_HISTORY_SUCCESS = "GET_WORK_ORDER_HISTORY_SUCCESS";

export const RESET_WORK_ORDER_LIST = "RESET_WORK_ORDER_LIST";

export const EXPORT_WORK_ORDER_LIST = "EXPORT_WORK_ORDER_LIST";

export const GET_CONTACT_INFO_ASYNC = "GET_CONTACT_INFO_ASYNC";
export const GET_CONTACT_INFO_SUCCESS = "GET_CONTACT_INFO_SUCCESS";

export const EDIT_CONTACT_INFO_ASYNC = "EDIT_CONTACT_INFO_ASYNC";

export const GET_LIST_CONTACT_PRIORITIZED_ASYNC =
  "GET_LIST_CONTACT_PRIORITIZED_ASYNC";
export const GET_LIST_CONTACT_PRIORITIZED_SUCCESS =
  "GET_LIST_CONTACT_PRIORITIZED_SUCCESS";

// SUBCONTRACTOR
export const SEARCH_SUBCONTRACTOR_WORK_ORDER_ASYNC =
  "SEARCH_SUBCONTRACTOR_WORK_ORDER_ASYNC";
export const SEARCH_SUBCONTRACTOR_WORK_ORDER_SUCCESS =
  "SEARCH_SUBCONTRACTOR_WORK_ORDER_SUCCESS";

export const RESOLVE_SUBCONTRACTOR_WORK_ORDER_ASYNC =
  "RESOLVE_SUBCONTRACTOR_WORK_ORDER_ASYNC";
export const RESOLVE_SUBCONTRACTOR_WORK_ORDER_SUCCESS =
  "RESOLVE_SUBCONTRACTOR_WORK_ORDER_SUCCESS";

export const PRINT_PREVIEW_SUBCONTRACTOR_WORK_ORDER_ASYNC =
  "PRINT_PREVIEW_SUBCONTRACTOR_WORK_ORDER_ASYNC";

export const SETUP_SUBCONTRACTOR_AWS_S3_ASYNC =
  "SETUP_SUBCONTRACTOR_AWS_S3_ASYNC";

export const GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC =
  "GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC";
export const GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC =
  "GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC";

export const GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC =
  "GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC";

export const EDIT_SUBCONTRACTOR_WORK_ORDER_SUCCESS =
  "EDIT_SUBCONTRACTOR_WORK_ORDER_SUCCESS";
export const EDIT_SUBCONTRACTOR_WORK_ORDER_ASYNC =
  "EDIT_SUBCONTRACTOR_WORK_ORDER_ASYNC";

// HOMEOWNERS

export const ADD_HOMEOWNER_WORK_ORDER_ASYNC = "ADD_HOMEOWNER_WORK_ORDER_ASYNC";
export const ADD_HOMEOWNER_WORK_ORDER_SUCCESS =
  "ADD_HOMEOWNER_WORK_ORDER_SUCCESS";

export const EDIT_HOMEOWNER_WORK_ORDER_ASYNC =
  "EDIT_HOMEOWNER_WORK_ORDER_ASYNC";
export const EDIT_HOMEOWNER_WORK_ORDER_SUCCESS =
  "EDIT_HOMEOWNER_WORK_ORDER_SUCCESS";

export const SETUP_HOMEOWNER_AWS_S3_ASYNC = "SETUP_HOMEOWNER_AWS_S3_ASYNC";

export const RE_OPEN_HOMEOWNER_WORK_ORDER_ASYNC =
  "RE_OPEN_HOMEOWNER_WORK_ORDER_ASYNC";

export const SIGN_OFF_HOMEOWNER_WORK_ORDER_ASYNC =
  "SIGN_OFF_HOMEOWNER_WORK_ORDER_ASYNC";

export const HOMEOWNER_SETUP_AWS_S3_ASYNC = "HOMEOWNER_SETUP_AWS_S3_ASYNC";

export const SIGN_OFF_HOMEOWNER_UPLOAD_ATTACHMENT_TO_S3_ASYNC =
  "SIGN_OFF_HOMEOWNER_UPLOAD_ATTACHMENT_TO_S3_ASYNC";

export const HOMEOWNER_UPLOAD_TO_SERVER_ASYNC =
  "HOMEOWNER_UPLOAD_TO_SERVER_ASYNC";

export const SUBMIT_DECLINED_HOMEOWNER_WORK_ORDER_ASYNC =
  "SUBMIT_DECLINED_HOMEOWNER_WORK_ORDER_ASYNC";

export const PRINT_PREVIEW_HOMEOWNER_WORK_ORDER_ASYNC =
  "PRINT_PREVIEW_HOMEOWNER_WORK_ORDER_ASYNC";

export const REASSIGN_MULTIPLE_WORK_ORDER_ASYNC =
  "REASSIGN_MULTIPLE_WORK_ORDER_ASYNC";
export const REASSIGN_MULTIPLE_WORK_ORDER_SUCCESS =
  "REASSIGN_MULTIPLE_WORK_ORDER_SUCCESS";

export const CHECK_HOMEOWNER_SIGNATURE_WO_ASYNC =
  "CHECK_HOMEOWNER_SIGNATURE_WO_ASYNC";
export const CHECK_HOMEOWNER_SIGNATURE_WO_SUCCESS =
  "CHECK_HOMEOWNER_SIGNATURE_WO_SUCCESS";

export const SAVE_FILTER_WO_ASYNC = "SAVE_FILTER_WO_ASYNC";
export const SAVE_FILTER_WO_SUCCESS = "SAVE_FILTER_WO_SUCCESS";

export const GET_SAVED_FILTERED_WO_LIST_ASYNC =
  "GET_SAVED_FILTERED_WO_LIST_ASYNC";
export const GET_SAVED_FILTERED_WO_LIST_SUCCESS =
  "GET_SAVED_FILTERED_WO_LIST_SUCCESS";

export const GET_SAVED_FILTERED_WO_VALUE_ASYNC =
  "GET_SAVED_FILTERED_WO_VALUE_ASYNC";
export const GET_SAVED_FILTERED_WO_VALUE_SUCCESS =
  "GET_SAVED_FILTERED_WO_VALUE_SUCCESS";

export const REMOVE_SAVED_FILTERED_WO_ASYNC = "REMOVE_SAVED_FILTERED_WO_ASYNC";
export const REMOVE_SAVED_FILTERED_WO_SUCCESS =
  "REMOVE_SAVED_FILTERED_WO_SUCCESS";

export const EDIT_SAVED_FILTERED_WO_ASYNC = "EDIT_SAVED_FILTERED_WO_ASYNC";
export const EDIT_SAVED_FILTERED_WO_SUCCESS = "EDIT_SAVED_FILTERED_WO_SUCCESS";

export const SEND_BULK_MAIL_ASYNC = "SEND_BULK_MAIL_ASYNC";
export const SEND_BULK_MAIL_SUCCESS = "SEND_BULK_MAIL_SUCCESS";
export const SEND_EMAIL_WO_DETAIL = "SEND_EMAIL_WO_DETAIL";
export const GET_LAST_RESOLVED_WORK_ORDER = "GET_LAST_RESOLVED_WORK_ORDER";
export const GET_LAST_RESOLVED_WORK_ORDER_SUCCESS =
  "GET_LAST_RESOLVED_WORK_ORDER_SUCCESS";
export const RESOLVE_CLOSE_DATE_UPDATE = "RESOLVE_CLOSE_DATE_UPDATE";
export const RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA =
  "RESOLVE_CLOSE_DATE_UPDATE_ON_REOPEN_NFA";
export const GET_LOT_PAID_FEATURE = "GET_LOT_PAID_FEATURE";
export const GET_LOT_PAID_FEATURE_SUCCESS = "GET_LOT_PAID_FEATURE_SUCCESS";



// WEBPACK FOOTER //
// ./src/Work-Orders/constants.js